import type { CRPlayerCard } from '@/types/qbot';

/**
 * The level as the game prints it.
 *
 * `displayLevel` is computed server-side by the enriching routes; trust it when
 * it's there. The fallback is only for the routes that don't send it
 * (`/decks/popular`, per-battle decks) and is knowingly approximate: it assumes
 * a 14-level display tier, which Supercell moved to 16 with Elite Levels. That
 * staleness is why the field exists — so never "simplify" this back to the
 * arithmetic alone.
 */
export function levelOf(card: CRPlayerCard): number {
  if (typeof card.displayLevel === 'number') return card.displayLevel;
  return card.maxLevel ? card.level + (14 - card.maxLevel) : card.level;
}

export function getForm(card: CRPlayerCard): 'base' | 'evolution' | 'hero' {
  const evoLvl = card.evolutionLevel ?? 0;
  const hasHero = Boolean(card.iconUrls?.heroMedium);
  const hasEvo = Boolean(card.iconUrls?.evolutionMedium);
  if (evoLvl >= 2 && hasHero) return 'hero';
  if (evoLvl >= 1 && hasEvo) return 'evolution';
  if (evoLvl >= 1 && hasHero) return 'hero';
  if (evoLvl === 0 && hasHero && !hasEvo) return 'hero';
  return 'base';
}
